// @ts-check

import { api } from '@/api'

/**
 * Returns a list of available PSD2 bank accounts
 * @returns {Promise<import('axios').AxiosResponse<*> & {
 *  personal_banks: Bank[]
 *  business_banks: Bank[]
 * }>}
 */
export const getBankList = async () => api.get(`integrations/psd2/bank-list`)

export const getLinkedBankAccounts = async () =>
  api.get(`integrations/psd2/accounts/linked`)

export const getUnhandledBankAccounts = async () =>
  api.get(`integrations/psd2/accounts/unhandled`)

export const startBankAuthentication = async (bankName, psuType) =>
  api.post(`integrations/psd2/start-authentication`, {
    psu_type: psuType,
    bank_name: bankName
  })

export function linkBankAccounts(accounts) {
  return api.post(`integrations/psd2/accounts/link`, { accounts })
}

export function deleteBankConnections(connectedBankAccountId) {
  return api.delete(`integrations/psd2/accounts/${connectedBankAccountId}`, {
    data: {
      confirm_delete_multiple: true
    }
  })
}

export const initiateFetchingBankTransactions = async () =>
  api.post(`integrations/psd2/fetch-bank-transactions`)

export function getFirstExpiringOrExpiredBankConnection() {
  return api.get(`integrations/psd2/accounts/next-expiring-connection`)
}
